import clsx from 'clsx'

import type { ButtonProps } from '@wartek-id/button-v1'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'

import type { FC } from 'react'

type ButtonSelengkapnyaProps = ButtonProps & {
  onClick?: () => void
}

const ButtonSelengkapnya: FC<ButtonSelengkapnyaProps> = ({
  disabled = false,
  onClick,
  ...props
}) => {
  if (disabled) {
    return (
      <Button
        size="sm"
        color="white"
        className={clsx(
          'select-none w-36',
          '!outline-none',
          '!border !border-solid !border-disabled',
          '!bg-surface-disabled'
        )}
        disabled
      >
        Belum tersedia
      </Button>
    )
  }

  return (
    <Button
      as="a"
      type={undefined}
      size="sm"
      color="white"
      className="select-none w-36"
      onClick={onClick}
      {...props}
    >
      <span>Selengkapnya</span> <Icon fontSize="sm">chevron_right</Icon>
    </Button>
  )
}
export default ButtonSelengkapnya
